document.addEventListener( 'DOMContentLoaded', () => {

	const templateUrl = window.themeVars?.templateUrl || '';
	const playIconPath = `${ templateUrl }/img/icons/player_play.svg`;

	if ( ! templateUrl ) {

		return;

	}

	const videos = document.querySelectorAll( '.wp-block-video video' );

	videos.forEach( ( video ) => {

		const figure = video.closest( '.wp-block-video' );
		if ( ! figure || figure.classList.contains( 'wp-block-video--enhanced' ) ) {

			return;

		}

		figure.classList.add( 'wp-block-video--enhanced' );

		const poster = video.getAttribute( 'poster' );
		if ( ! poster ) {

			return;

		}

		figure.classList.add( 'wp-block-video--poster' );
		video.setAttribute( 'preload', 'none' );
		video.removeAttribute( 'controls' );

		const sourceNodes = Array.from( video.querySelectorAll( 'source[src]' ) );
		const hasSourceNodes = sourceNodes.length > 0;
		const inlineSrc = video.getAttribute( 'src' );

		if ( hasSourceNodes ) {

			sourceNodes.forEach( ( source ) => {

				source.dataset.src = source.getAttribute( 'src' ) || '';
				source.removeAttribute( 'src' );

			} );
			video.load();

		} else if ( inlineSrc ) {

			video.dataset.src = inlineSrc;
			video.removeAttribute( 'src' );
			video.load();

		}

		const playButton = document.createElement( 'button' );
		playButton.type = 'button';
		playButton.className = 'wp-block-video__play';
		playButton.setAttribute( 'aria-label', 'Odtwórz film' );
		playButton.innerHTML = `<img src="${ playIconPath }" alt="" loading="lazy" decoding="async">`;

		figure.appendChild( playButton );

		playButton.addEventListener( 'click', () => {

			if ( hasSourceNodes ) {

				sourceNodes.forEach( ( source ) => {

					if ( source.dataset.src && ! source.getAttribute( 'src' ) ) {

						source.setAttribute( 'src', source.dataset.src );

					}

				} );
				video.load();

			} else if ( video.dataset.src && ! video.getAttribute( 'src' ) ) {

				video.setAttribute( 'src', video.dataset.src );
				video.load();

			}

			video.setAttribute( 'controls', 'controls' );
			video.play();

		} );

		video.addEventListener( 'play', () => {

			figure.classList.add( 'is-playing' );

		} );

		video.addEventListener( 'pause', () => {

			figure.classList.remove( 'is-playing' );

		} );

		video.addEventListener( 'ended', () => {

			figure.classList.remove( 'is-playing' );

		} );

	} );

} );
